import React, { useState, useContext, useEffect, createRef } from 'react';
import { Window, WindowActionsBar } from '@progress/kendo-react-dialogs';
import { NEW, VIEW, UPDATE } from '../../assets/Constants/actionsTypes'
import { useTranslation } from 'react-i18next';
// * Helpers
import API from "../../services/api";
import AuthContext from '../../context/Auth/AuthContext';
import Notifications, { ERROR_NOTIFICATION } from '../../helpers/notifications';
const ScenarioModal = (props) => {
    // we call the hook to make translations
    const { t } = useTranslation('common');
    // we create a reference for the modal
    const window = createRef();
    // this variable allow us know if the save button will be shown or not
    const [showSave, setShowSave] = useState(false);
    // if is in UPDATE mode
    const [isUpdate, setIsUpdate] = useState(false);
    // Inputs state
    const [code, setCode] = useState('');
    const [name, setName] = useState('');
    const [finalYear, setFinalYear] = useState('');
    const [description, setDescription] = useState('');
    const [modelsList, setModelsList] = useState([]);
    const [selectedModel, setSelectedModel] = useState(0);
    // Session context to get the current institution data
    const { get_currentInstitution } = useContext(AuthContext);

    /**
     * here you define the configuration that the modal will have. this depends on the type with which it was opened.
    */
    useEffect(() => {
        getModelsList();
        if (props.type === NEW) {
            setShowSave(true);
            setCode('');
            setName('');
            setDescription('');
            setFinalYear('');
        } else {
            if (props.data) {
                setCode(props.data.code);
                setName(props.data.name);
                setDescription(props.data.description);
                setSelectedModel(props.data.modelId);
                setFinalYear(props.data.finalYear);
                if (props.type === VIEW) {
                    setShowSave(false)
                } else {
                    if (props.type === UPDATE) {
                        setShowSave(true);
                        setIsUpdate(true);
                    }
                }
            } else {
                props.toggleWindow();
            }
        }

    }, [props]); // eslint-disable-line react-hooks/exhaustive-deps

    // with this we make sure to always hide the maximize and minimize buttons.
    // Also, with this useEffect we get the list of models to show in the select option
    useEffect(() => {
        if (window) {
            hideButtons();
        }
    })

    // Returns the list of models to be displayed in the select option
    const getModelsList = async () => {
        setModelsList([]);
        try {
            // data from API
            const response = await API.get(`/model/getAllCompleted?institutionId=${get_currentInstitution().catInstitutionId}`);
            setModelsList(response.data.data === null ? [] : response.data.data);
            // The state of the selected model changes with the OnChange. 
            // So if the user does not change and leaves the first element, the modelId will be 0. 
            // So it must be set manually to avoid this error
            if(props.type === NEW) {
                if(response.data.data === null || response.data.data === []) {
                    // Sets the state in 0 to show a error message
                    setSelectedModel(0);
                } else {
                    response.data.data.forEach((value, index) => {
                        // first element modelId to set the state
                        if(index === 0){
                            setSelectedModel(value.modelid);
                        }
                    }); 
                }
            }
        } catch (e) {
            Notifications.notify(String(e), ERROR_NOTIFICATION);
            console.log(e);
        }
    }

    // with this we hide the maximize and minimize buttons.
    const hideButtons = () => {
        let maximizeButton = window.current.windowElement.querySelector(
            ".k-i-window-maximize"
        ).parentElement;
        maximizeButton.style.visibility = "hidden";

        let minimizeButton = window.current.windowElement.querySelector(
            ".k-i-window-minimize"
        ).parentElement;
        minimizeButton.style.visibility = "hidden";
    }

    return (
        <div className="">
            <Window
                className="ilo-k-window"
                initialHeight={440}
                modal={true}
                title={t('scenarios.modalTitle')}
                resizable={false}
                draggable={false}
                doubleClickStageChange={false}
                onClose={() => {
                    props.toggleWindow();
                }}
                ref={window}
            >
                <div className="container-fluid m-1">
                    <div className="form-group row">
                        {/*Code row*/}
                        <div className="col-sm-6">
                            <label className="required ilo_lbl_general">{t('scenarios.code_ipt')}</label>
                            <input
                                type="text"
                                disabled={!showSave}
                                className="form-control sc_inputs"
                                placeholder={t('scenarios.code_ipt')}
                                value={code}
                                onChange={(e) => setCode(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="required ilo_lbl_general">{t('scenarios.name_ipt')}</label>
                            <input
                                type="text"
                                disabled={!showSave}
                                className="form-control sc_inputs"
                                placeholder={t('scenarios.name_ipt')}
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </div>
                    </div>
                    <div className="form-group row">
                        {/*Name row*/}
                        <div className="col-sm-6">
                            <label className="required ilo_lbl_general">{t('scenarios.finalYear')}</label>
                            <input
                                type="text"
                                disabled={!showSave || isUpdate}
                                className="form-control sc_inputs"
                                placeholder={t('scenarios.finalYear')}
                                value={finalYear}
                                onChange={(e) => setFinalYear(e.target.value)}
                            />
                        </div>
                        <div className="col-sm-6">
                            <label className="required ilo_lbl_general">{t('scenarios.model_ipt')}</label>
                            <select value={selectedModel} onChange={(e) => { setSelectedModel(e.target.value) }} disabled={!showSave || isUpdate} className="form-control sc_inputs">
                                {modelsList.map((model) => {
                                    return (
                                        <option key={model.modelid} value={model.modelid}>
                                            {`${model.code} - ${model.name}`}
                                        </option>
                                    );
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="form-group row">
                        {/*Description row*/}
                        <div className="col-sm-12">
                            <label className="ilo_lbl_general">{t('scenarios.desc_ipt')}</label>
                            <textarea
                                disabled={!showSave}
                                className="form-control ilo-input ilo-modal-input-text-area"
                                rows="5"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                            ></textarea>
                        </div>
                    </div>
                    <WindowActionsBar layout="end">
                        {showSave &&
                            <button
                                onClick={() => {
                                    const modelData = modelsList.find((item)=>{
                                        return item.modelid === parseInt(selectedModel, 10)
                                    });
                                    
                                    const data = {
                                        scenarioId: isUpdate ? parseInt(props.data.scenarioId, 10) : 0,
                                        code,
                                        modelId: modelData? modelData.modelid : 0,
                                        name,
                                        description: description === '' ? null : description,
                                        finalYear: parseInt(finalYear, 10),
                                        baseYear: modelData? modelData.baseYear : 0
                                    }
                                    
                                    props.onSave(data)
                                }}
                                className="btn btn-primary ilo-btn"
                            >{t('modals.save_btn')}</button>
                        }

                        <button onClick={props.toggleWindow} className="btn btn-primary ilo-btn">{showSave ? t('modals.cancel_btn') : t('modals.close_btn')}</button>
                    </WindowActionsBar>
                </div>
            </Window>
        </div>
    );
}

export default ScenarioModal